import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-computer-aplication',
  templateUrl: './bsc-computer-aplication.component.html',
  styleUrls: ['./bsc-computer-aplication.component.scss']
})
export class BscComputerAplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
